var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { background: "#fff" } }, [
    _c(
      "div",
      {
        staticStyle: {
          padding: "10px",
          "font-size": "14px",
          "text-align": "left"
        }
      },
      [
        _c("p", [
          _vm._v(
            "您的设备：" +
              _vm._s(_vm.query.iccid) +
              "，已于" +
              _vm._s(_vm.query.expireDate) +
              "到期"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "为了不影响您的使用，或由于长期未续费导致设备注销， 请您及时进行续费。"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "若设备丢失或已注销无法续费，您可以点击下方更换设备，获取新的设备"
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          width: "200px",
          margin: "1rem auto",
          "font-size": "22px"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "gumaibtn",
            staticStyle: {
              float: "left",
              display: "inline-block",
              width: "80px",
              height: "80px",
              background: "#0e65b1",
              color: "#fff"
            },
            on: { click: _vm.exchange }
          },
          [
            _c("div", { staticStyle: { "margin-top": "10px" } }, [
              _vm._v("更换")
            ]),
            _c("div", [_vm._v("设备")])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "xufei",
            staticStyle: {
              display: "inline-block",
              width: "80px",
              height: "80px",
              background: "#08a543",
              color: "#fff",
              "margin-left": "40px"
            },
            on: { click: _vm.recharge }
          },
          [
            _c("div", { staticStyle: { "margin-top": "10px" } }, [
              _vm._v("立即")
            ]),
            _c("div", [_vm._v("续费")])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b4b3bbb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b4b3bbb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/expirenotice.vue
// module id = null
// module chunks = 